<template>
  <tr>
    <td>
      <v-select
        v-model="localModelValue.bot_id"
        label="Bot"
        :items="bots"
        item-text="name"
        item-value="id"
        dense
        placeholder="Bot"
        :loading="isLoading"
        :rules="[v => !!v || 'Bot required']"
        hide-details
      />
    </td>
    <td>
      <select-project
        v-model="localModelValue.entity_id"
      />
    </td>
    <td>
      <v-select
        v-model="localModelValue.type"
        label="Type"
        :items="triggerTypes"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="localModelValue.chat_id"
        label="Chat ID"
        hide-details
      />
    </td>
    <td class="actions align-center d-flex">
      <v-btn
        icon
        color="primary"
        :disabled="!localModelValue.entity_id || !localModelValue.type || !localModelValue.bot_id || !localModelValue.chat_id"
        @click="$emit('save', localModelValue)"
      >
        <v-icon>
          save
        </v-icon>
      </v-btn>
      <v-btn
        icon
        color="error"
        @click="$emit('close')"
      >
        <v-icon>
          close
        </v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import { cloneDeep } from 'lodash'
import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

export default {
  components: {
    SelectProject,
  },
  props: {
    isLoading: Boolean,
    bots: {
      type: Array,
      required: true,
    },
    trigger: {
      type: Object,
      required: true,
    },
    triggerTypes: {
      type: Array,
      required: true,
    }
  },

  data() {
    return {
      localModelValue: {},
    }
  },

  mounted() {
    this.localModelValue = cloneDeep(this.trigger)
  },
}
</script>
